import React from 'react'

function AttendanceHeader({ setIsAdding }) {
    return (
        <header>
            <h2>Student Attendance List </h2>            
        </header>
    )
}

export default AttendanceHeader